module.exports = __webpack_public_path__ + "img/private.84479639.png";